import * as React from 'react';

function SvgHotbait(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.758 6.197s.419 4.694-3.638 5.6C14.484 5.341 8.264 1.62 5.867 1c.679 1.532.679 3.28 0 4.811-.99 2.565-5.03 4.141-4.862 8.835A7.075 7.075 0 005.867 21a3.906 3.906 0 010-.889 4.124 4.124 0 118.231 0c-.003.27-.031.54-.084.805a7.527 7.527 0 004.208-4.241c1.056-3.403 1.056-7.477-2.464-10.478z"
        strokeWidth={1.5}
        stroke="currentColor"
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgHotbait;
